<div *ngIf="isEdit else dataForm">
  <div bsModal
       #staticModal="bs-modal"
       class="modal fade"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog" style="width: 53%;">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title" translate>CONTRACT_LINK_MODAL_LINK_CONTRACT_COMPANY_SUBSCRIPTIONS</h4>
        </div>
        <div class="modal-body">
          <div class="portlet-body">
            <div class="space-title"  translate>CONTRACT_MODAL_SELECTED_SUBSCRIPTIONS</div>
            <div *ngFor="let item of selectedSub; let i = index " class="space">
              <span>{{i+1}})</span>
              <span>{{item.name}}</span>
              <span class="right"><i class="fal fa-trash-alt" (click)="remove(i)"></i></span>
            </div>
            <br>
            <form [formGroup]="myForm" style="width:100%" class="link_box">
              <storever-element-group
                [icon]="'fa-address-book'"
                [title]="'none'"
                [config]="formConfig.config"
                [form]="myForm">
              </storever-element-group>
            </form>
            <br>

            <div class="help-block error" *ngIf="error !== 'false'">{{error}}</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" [disabled]="selectedSub.length === 0  || myForm.invalid || error"
          id="CONTRACT_LINK_MODAL_LINK"  (click)="send(myForm.value)"> {{'CONTRACT_LINK_MODAL_LINK' | translate:locale.language}} </button>
          <button type="button" class="btn btn-default" (click)="close()">{{'CANCEL' | translate:locale.language}}</button>

        </div>
      </div>
    </div>
  </div>

</div>
<!--this template is used when we call this modal via data table-->
<ng-template #dataForm >
    <div class="modal-content" style="width: 135%;height: 112%">
      <div class="modal-header" >
        <button type="button" class="close" aria-label="Close" (click)="closeBSF()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" translate>CONTRACT_LINK_MODAL_LINK_CONTRACT_COMPANY_SUBSCRIPTIONS
          <span *ngIf="!selectedOneItem && selectedItem?.length" translate>({{selectedItem?.length}} selected subscriptions)</span></h4>
      </div>
      <div class="modal-body">
        <div class="portlet-body">
           <span *ngIf="selectedOneItem ; else multiItems">
          <storever-header-subtitle [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: selectedOneItem.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: selectedOneItem?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: selectedOneItem.productName},
           {icon: 'fa-shipping-fast fal', title: 'GENERIC_DELIVERY_DATE', name: selectedOneItem?.deliveryDate | date: 'dd/MM/yyyy'}]"></storever-header-subtitle>
      </span>
          <ng-template #multiItems >
            <div class="help-block error" *ngIf="!checkProductType()" translate>SUBSCRIPTION_SELECTED_WITH_DIFFERENT_PRODUCT</div>
            <div [ngClass]="selectedItem?.length > 6 ? 'scroll' : null" >
          <span *ngFor="let item of selectedItem let i = index " >
          <storever-header-subtitle [isAllowedRemove]="true" [datas]="[
           {icon: 'fa-users', title: 'GENERIC_CLIENT', name: item.clientName},
           {icon: 'fa-map-marker-alt', title: 'GENERIC_SITE', name: item?.name},
           {icon: 'fal fa-box', title: 'GENERIC_PRODUCT', name: item.productName},
           {icon: 'fa-shipping-fast fal', title: 'GENERIC_DELIVERY_DATE', name: item?.deliveryDate | date: 'dd/MM/yyyy' }]">
           <i class="fal fa-trash-alt" *ngIf="selectedItem?.length > 1" style="margin-top:6px" tooltip="{{ 'DELETE' | translate:locale.language}}" (click)="removeSubscription(i)"></i>
          </storever-header-subtitle>
      </span>
            </div>
          </ng-template >
          <span *ngIf="!isAnomalies">
          <div class="space-title"  translate>CONTRACT_MODAL_SELECTED_SUBSCRIPTIONS</div>
          <div *ngFor="let item of selectedSub; let i = index " class="space">
            <span>{{i+1}})</span>
            <span>{{item.name}}</span>
            <span class="right"><i class="fal fa-trash-alt" (click)="remove(i)"></i></span>
          </div>
          </span>
          <br>
          <form [formGroup]="myForm" style="width:100%" class="link_box">
            <storever-element-group
              [icon]="'fa-address-book'"
              [title]="'none'"
              [config]="formConfig.config"
              [form]="myForm">
            </storever-element-group>
          </form>
          <br>
          <span *ngIf="!isAnomalies">
          <div class="space-title"  translate>CONTRACT_MODAL_SELECTED_SUBSCRIPTIONS</div>
          <div class="help-block error" *ngIf="error !== 'false'">{{error}}</div>
          </span>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" [disabled]="selectedSub.length === 0 || myForm.invalid || error || !checkProductType()"
        id="CONTRACT_LINK_MODAL_LINK"   (click)="send(myForm.value)"> {{'CONTRACT_LINK_MODAL_LINK' | translate:locale.language}} </button>
        <button type="button" class="btn btn-default" (click)="closeBSF()">{{'CANCEL' | translate:locale.language}}</button>
      </div>
    </div>
</ng-template>

